"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _actionCreators = require('shared/actions/actionCreators'); var _actionCreators2 = _interopRequireDefault(_actionCreators);




const initialState = null

 function currentPatientReducer (
  state = initialState,
  action,
) {
  switch (action.type) {
    case _actionCreators2.default.loadPatientConversationByCodeActions.SUCCESS.type:
    case _actionCreators2.default.getPatientConversationMessagesActions.SUCCESS.type:
      return action.payload.CurrentPatientKey || state
    default:
      return state
  }
} exports.default = currentPatientReducer;
